import type { EmployeeImportFormat } from '@/common/graphql';

/** Discriminator for the Managerial Accounting entry in the shared import type selection — not a GraphQL enum value. */
export const MANAGERIAL_ACCOUNTING_IMPORT_TYPE = 'MANAGERIAL_ACCOUNTING' as const;

export type ImportSelectionValue =
  | EmployeeImportFormat.Create
  | EmployeeImportFormat.GeneralInformation
  | EmployeeImportFormat.JobHistoryContract
  | typeof MANAGERIAL_ACCOUNTING_IMPORT_TYPE;

export interface ImportModalFormData {
  action: ImportSelectionValue | null;
  link: string;
}
